import { useAuth } from 'context/AuthContext';
import { toRecentRecognition } from 'pages/Dashboard/components/recent-recognitions.format';
import { getReconhecimentosDoPrefixo, RECONHECIMENTOS_POR_PAGINA } from 'services/home-feed.service';
import { textoDaContagem } from 'utils/strings';

import { CartaoDeReconhecimento, ESTILO_DO_CARTAO } from './components/UltimosReconhecimentos';
import PaginaDoFeed from './components/PaginaDoFeed';
import { useListaDoPrefixo } from './useListaDoPrefixo';

/** Todos os reconhecimentos do ciclo enviados pelo prefixo de quem acessa, lidos ao vivo (AJ3-01 a AJ3-07). */
export default function ReconhecimentosDoPrefixo() {
  const { userInfo, cycleSelected } = useAuth();
  const cycleId = cycleSelected?._id;

  const lista = useListaDoPrefixo(
    cycleId ? (pagina: number) => getReconhecimentosDoPrefixo(cycleId, pagina) : undefined,
    cycleId ?? '',
    RECONHECIMENTOS_POR_PAGINA,
  );
  const agora = Date.now();
  // O título segue o prefixo que filtrou a lista; até a resposta chegar, o do `find/info`.
  const prefixo = lista.prefixo ?? userInfo?.prefixo;

  return (
    <PaginaDoFeed
      titulo={prefixo ? `Reconhecimentos do prefixo ${prefixo}` : 'Reconhecimentos do prefixo'}
      estado={lista.estado}
      textoDoErro="Não foi possível carregar os reconhecimentos do prefixo."
      textoDoVazio="Ainda não há reconhecimentos no seu prefixo neste ciclo."
      onTentarDeNovo={lista.tentarDeNovo}
      resumo={`${textoDaContagem(lista.total, 'reconhecimento', 'reconhecimentos')} no ciclo`}
      totalDePaginas={Math.ceil(lista.total / RECONHECIMENTOS_POR_PAGINA)}
      pagina={lista.pagina}
      onPagina={lista.irParaPagina}
      rotuloDaPaginacao="Paginação dos reconhecimentos do prefixo"
    >
      <ul className="m-0 grid list-none grid-cols-1 gap-5 px-1 pb-2.5 pt-2 md:grid-cols-3">
        {lista.itens.map((item, indice) => (
          <CartaoDeReconhecimento
            key={item._id}
            item={toRecentRecognition(item, agora)}
            estilo={ESTILO_DO_CARTAO[indice % ESTILO_DO_CARTAO.length]}
          />
        ))}
      </ul>
    </PaginaDoFeed>
  );
}
